import React, { useState } from "react";
import { Spinner, Container } from "react-bootstrap";
import { useCustomScreen, useScreenSize } from "../Utils";

export const Loader = ({ response, action }) => {
  const {
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isXlScreen,
    isXxlScreen,
    is4kScreen,
  } = useScreenSize();
  if (response) {
    return (
      <Spinner
        animation="border"
        role="status"
        style={{ padding: is4kScreen ? "0.5rem" : "" }}
      ></Spinner>
    );
  } else {
    return (
      <span style={{ fontSize: is4kScreen ? "1.8rem" : "", padding: "1rem" }}>
        {action}
      </span>
    );
  }
};

export const LoadingIndicator = () => {
  const {
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isXlScreen,
    isXxlScreen,
    is4kScreen,
  } = useScreenSize();
  return (
    <Container
      style={{ height: "100vh" }}
      className="w-100% d-flex justify-content-center align-items-center"
    >
      <Spinner animation="border" role="status"></Spinner>
    </Container>
  );
};
